import * as ActionTypes from '../action-types'

/**
 * Constant
 */


const vamVehicleIssue_DefaultState = {
    byID: {},
    comments: [],
    allIDs: []
}

export const vamVehicleIssue = (state = vamVehicleIssue_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) { 

        case ActionTypes.GET_VAM_VEHICLE_ISSUES: {

            const { issues } = action

            issues
            &&
            issues.map(vi => {
                const { vamiid } = vi

                newState.byID[vamiid] = vi

                if(!newState.allIDs.includes(vamiid)) newState.allIDs.push(vamiid)
            })

            return newState
        }
        case ActionTypes.ADD_VAM_VEHICLE_ISSUE: {
            const { issue } = action
            const { vamiid } = issue

            newState.byID[vamiid] = issue

            return newState
        } 
        case ActionTypes.EDIT_VAM_VEHICLE_ISSUE: {
            const { issue } = action
            const { vamiid } = issue

            if (vamiid) newState.byID[vamiid] = issue
            
            return newState
        }
        case ActionTypes.GET_COMMENT_VAM_VEHICLE_ISSUE: {
            const { comments } = action;
      
            newState.comments = comments;
      
            return newState;
          }
          case ActionTypes.CREATE_COMMENT_VAM_VEHICLE_ISSUE: {
            const comment = action.comment;
            const { vamicid } = comment;
      
            if (!newState.comments.some((n) => n.vamicid === vamicid)) {
              newState.comments.push(comment);
            }
      
            return newState;
          }
          case ActionTypes.UPDATE_COMMENT_VAM_VEHICLE_ISSUE: {
            const comment = action.comment;
            const { vamicid } = comment;
      
            newState.comments = newState.comments.map((n) => {
              if (n.vamicid === vamicid) {
                return comment;
              }
              return n;  
            });
      
            return newState;
          }
          case ActionTypes.DELETE_COMMENT_VAM_VEHICLE_ISSUE: {
            const vamicid = action.vamicid
      
            newState.comments = newState.comments.filter((n) => n.vamicid !== vamicid);
      
            return newState;
          }
          case ActionTypes.CLOSE_COMMENT_VAM_VEHICLE_ISSUE: {
            newState.comments = []
            return newState;
          }
        
        default: {
            return newState;
        }
    }
}